
const $ = jQuery.noConflict();

'use strict';
const FormLabel = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domInputTextarea: $('.wpcf7-form input, .wpcf7-form textarea'),
	$domCF7: $('.wpcf7-form'),
	slWrapperInput: '.contact-touch__wrapper-input, .contact-brochure__wrapper-input, .contact-career__wrapper-input',
	slInputLabel: '.contact-touch__wrapper-label, .contact-brochure__wrapper-label, .contact-career__wrapper-label',
	slInputControl: '.wpcf7-form-control',
	classMoved: 'is-moved',

	/** @description Initialize */
	init: function() {
		this.formMove();
		this.formAutofill();
		this.customFile();
	},

	/** @description Bind Events */
	formMove: function() {
		this.$domInputTextarea.each(function() {
			if ($(this).val().length !== 0) { //In case there is a preloaded value
				FormLabel.getInputLabel(this).addClass(FormLabel.classMoved);
			} else {
				FormLabel.getInputLabel(this).removeClass(FormLabel.classMoved);
			}
        });
        
        this.$domCF7.on('focus', '.select2-selection, input, textarea', function() { //On focus move the label
			FormLabel.getInputLabel(this).addClass(FormLabel.classMoved);
		});
		this.$domCF7.on('blur', '.select2-selection, input, textarea', function() {
			if ($(this).val().length === 0 && !$(this).find('.select2-selection__rendered').attr('title')) {
				FormLabel.getInputLabel(this).removeClass(FormLabel.classMoved);
			}
		});
	},

	getInputLabel: function(selector) {
		return $(selector).parents(this.slWrapperInput).find(this.slInputLabel);
	},

	formAutofill: function() {
		FormLabel.$domInputTextarea.attr('autocomplete', 'negative');
	},

	customFile: function(){
		$('.add-file').on('change', (e)=> {
			const _self = $(e.currentTarget);
			if(_self[0].files.length < 1) {
				_self.parent().siblings('.js-custom-file').text('');
				_self.parent().siblings('.js-custom-file').removeClass('show-icon');
			} else {
				const text = _self[0].files[0].name;
				_self.parent().siblings('.js-custom-file').text(text);
				_self.parents('.contact-career__wrapper-input--file').find('label').css("opacity", "0");
			}
		});
	},
};

export default FormLabel;